<template>
    <div>
        <validation-observer #default="{ invalid }" ref="observer">
            <span class="display-none">{{ invalid }}</span>
            <b-form ref="formular">
                <div class="white-box mt-3">
                    <div class="data-group">
                        <M3FormTitle title="Contul bancar" :checked="completed"></M3FormTitle>
                        <div class="flex space-between position-relative">
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                                class="first-input"
                                style="width: 50%;"
                            >
                                <b-form-group
                                    id="fieldset-horizontal"
                                    label-cols-lg="3"
                                    content-cols-lg="9"
                                    label="Cont bancar"
                                    class="has-icon"
                                >
                                    <b-form-input
                                        id="name"
                                        v-model="form.iban"
                                        type="text"
                                        style="text-transform: uppercase;"
                                        name="message"
                                        :state="errors.length > 0 ? false : null"
                                        :readonly="completed"
                                    ></b-form-input>
                                    <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                                class="first-input"
                                style="width: 50%;"
                            >
                                <b-form-group
                                    id="fieldset-horizontal"
                                    label-cols-lg="3"
                                    content-cols-lg="9"
                                    label="Banca"
                                >
                                    <b-form-input
                                        v-model="form.bank"
                                        :state="errors.length > 0 ? false : null"
                                        :readonly="completed"
                                        type="text"
                                    >
                                    </b-form-input>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-group>
                            </validation-provider>
                        </div>
                        <hr class="mt-5">
                        <b-form-checkbox
                            v-model="completed"
                            switch
                            size="lg"
                            class="switch-box"
                            @change="completeForm(completed)"
                        >Informațiile sunt complete și corecte</b-form-checkbox>
                    </div>
                    <img src="@/assets/images/M3/M3Sketch/termenesmall.png" class="termene-icon">
                </div>

            </b-form>
        </validation-observer>
    </div>
</template>

<script>
    import { BForm, BFormInput, BFormGroup, BButton, BFormCheckbox, BIconCheckCircleFill, BIconXCircleFill, BFormRadioGroup } from 'bootstrap-vue'
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    require('@/helpers/validations/validations')
    import M3FormTitle from '../M3FormTitle'
    import vSelect from "vue-select";
    import api from '@/helpers/api';
    import axios from '@/helpers/axios';
    export default {
        components: {
            BForm,
            BFormInput,
            BFormGroup,
            BButton,
            BFormCheckbox,
            M3FormTitle,
            BIconCheckCircleFill,
            BIconXCircleFill,
            BFormRadioGroup,
            ValidationProvider,
            ValidationObserver,
            vSelect
        },
        props: {
            bankInfo: {}
        },
        data() {
            return {
                form: {
                    iban: '',
                    bank: '',
                },
                completed: false,
                caenName: '',
                options: [
                    { text: 'Proiectul vizează codul CAEN principal', value: '1' },
                    { text: 'Proiectul vizează un cod CAEN secundar eligibil  (vă rugăm selectați din lista de mai jos un cod CAEN eligibil)', value: '2' },
                ],
                data: null,
            }
        },
        watch:{
            bankInfo: {
                handler: function() {
                    this.data = this.bankInfo
                    this.form.iban = this.data.iban
                    this.form.bank = this.data.bank

                },
                deep: false
            },
        },
        mounted() {
            axios.get(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/project/checks')
                .then( response => {

                    this.completed = JSON.parse(response.data).proiectulMeuContBancar;
                    if(this.completed)
                        this.$emit('formComplete')
                    else
                        this.$emit('formIncomplete')
                })
        },
        methods: {
            completeForm(event) {
                if(!event) {
                    axios.get(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/project/checks')
                        .then( response => {
                            let checks = JSON.parse(response.data);

                            checks.proiectulMeuContBancar = false;
                            axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/project/checks', {checks: JSON.stringify(checks)})
                                .then(()=>{
                                    this.$emit('formIncomplete')
                                })
                        })
                }
                else {
                    this.$refs.observer.validate().then((e) => {
                        if(!e) {
                            this.completed = false
                            this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                        } else{

                            axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/project', this.form)
                                .then((firstResponse) => {
                                    axios.get(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/project/checks')
                                        .then( response => {
                                            let checks = JSON.parse(response.data);

                                            checks.proiectulMeuContBancar = true;
                                            axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/project/checks', {checks: JSON.stringify(checks)})
                                                .then( () => {
                                                    this.$toast.success(firstResponse.data)
                                                    this.$emit('formComplete')
                                                })
                                        })
                                }).catch((xhr) => {
                                    if (xhr.status === 422) {
                                        this.errors.record(xhr.responseJSON.errors);
                                    }
                                    this.$toast.error(xhr.response.data.message);
                                });
                        }

                    })
                // this.$refs.formular.submit()
                }
            },
        }
    }
</script>

<style scoped>
.text-danger{
    width: 100%;
    white-space: pre;
}
.flex{
    display: flex;
}
.space-between{
    justify-content: space-between;
}
.white-box{
    background: #fff;
    padding: 20px;
    position: relative;
}
.data-group{
    margin: auto;
    width: 85%;
}
.form-group >>> legend{
    text-align: right;
    font-size: 12px !important;
    color: #777e90;
    font-weight: 500;
}
.form-group >>> input, input{
    border-radius: 2px;
    padding: 5px 10px;
    height: inherit;
    font-size: 14px;
    max-height: 30px;
    font-weight: 700;
    color: #767a95;
    background: #e9ecef;
}
.form-group >>> input:read-only{
    background: #a1fff1;
}
.form-group >>> .form-row{
    align-items: flex-start;
}
.has-icon{
    position: relative;
}
.has-icon img{
    position: absolute;
    top: 10px;
    right: 20px;
    opacity: 0.3;
}
.caen-input p{
    text-align: right;
    font-size: 12px !important;
    color: #777e90;
    font-weight: 500;
}
.caen-input >>> label{
    font-size: 12px !important;
    color: #777e90;
    font-weight: 500;
    line-height: 23px;
}
.warn p{
    margin: 0;
    font-size: 12px;
    color: #777e90;
}
.warn p:first-child{
    font-weight: 500;
    font-size: 14px;
}
.switch-box{
    text-align: right;
}
.switch-box >>> input, .switch-box >>> label{
    cursor: pointer;
}
.switch-box >>> label{
    font-size: 14px !important;
    color: #38393c;
    line-height: 1.9 !important;
}
.v-select >>> .vs__dropdown-menu {
    background: #e9ecef;
    max-height: 200px;
    overflow-y: auto;
}
.v-select >>> .vs__dropdown-toggle{
    background: #e9ecef;
    margin: 0;
    border-radius: 2px;
    max-height: 33px;
}
.v-select >>> .vs__dropdown-option {
    color: #767a95;
    font-size: 14px;
    font-weight: 600;
}
.v-select >>> .vs__search{
    margin: 0;
    padding: 0;
}
.v-select >>> .vs__selected-options {
  flex-wrap: nowrap;
  max-width: calc(100% - 41px);
}

.v-select >>> .vs__selected {
  color: #767a95;
  font-size: 14px;
  font-weight: 600;
  margin: 0;
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
  overflow: hidden;
}
.disabled-select{
    background: #a1fff1 url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px;
    pointer-events: none;
}
.disabled-select >>> .vs__dropdown-toggle{
    background: #d1f5ea!important;
    color:#b2b6be!important;
}
.disabled-select >>> input{
    background: #d1f5ea!important;
    color:#b2b6be!important;
}
@media (max-width: 1700px){
    .white-box{
        padding: 20px 35px;
    }
}
</style>